import * as React from "react";
import { cn } from "@/lib/utils";

interface ResponsiveTableProps {
  children: React.ReactNode;
  className?: string;
  /** Rendered instead of the table on <md screens. */
  mobileFallback?: React.ReactNode;
}

/** Horizontal scroll on small screens; optional card-list fallback on phones. */
export const ResponsiveTable = ({ children, className, mobileFallback }: ResponsiveTableProps) => (
  <>
    {mobileFallback && <div className="md:hidden">{mobileFallback}</div>}
    <div className={cn("overflow-x-auto", mobileFallback && "hidden md:block", className)}>{children}</div>
  </>
);
